import React from 'react';

import { BadgeVariantT } from '@consumer-frontend/shared-ui';

import { NcBadge } from '../NcBadge';

import '@consumer-bootstrap/netcredit.scss';

export const STATIC_BADGE_TYPES = [
  'AUTOPAY',
  'AUTOPAY_PENDING',
  'AUTOPAY_SCHEDULED',
  'PAID',
  'PAYMENT_PENDING',
] as const;

export type StaticBadgeTypeT = typeof STATIC_BADGE_TYPES[number];

export type NcStaticBadgeConfigT = {
  text: string;
  variant: BadgeVariantT;
};

export const staticBadgeConfigs: Record<StaticBadgeTypeT, NcStaticBadgeConfigT> = {
  AUTOPAY: {
    text: 'AutoPay',
    variant: 'success',
  },
  AUTOPAY_PENDING: {
    text: 'AutoPay Pending',
    variant: 'pending',
  },
  AUTOPAY_SCHEDULED: {
    text: 'AutoPay Scheduled',
    variant: 'success',
  },
  PAID: {
    text: 'Paid',
    variant: 'pending',
  },
  PAYMENT_PENDING: {
    text: 'Payment Pending',
    variant: 'pending',
  },
};

export type NcStaticBadgePropsT = {
  config: NcStaticBadgeConfigT;
};

export type NcStaticBadgeT = React.FC<NcStaticBadgePropsT>;

export const NcStaticBadge: NcStaticBadgeT = ({ config }) => <NcBadge {...config} />;
